<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
            v-toolbar-title(v-model="title") {{ title }}
          v-divider
          PrintEwaskatList(
            :title='title'
            :ip='getIp()'
          )
</template>

<script>
import * as config from "../config/index.json";
import PrintEwaskatList from "@/components/PrintEwaskatList.vue";
import { mapState } from "vuex";
import helper from "../helper/index.js";
export default {
  name: "PrintEwaskat",
  components: {
    PrintEwaskatList
  },
  data () {
    return {
      config: config.default,
      title: 'Cetak E-Waskat',
      ip: {
        headers: [
          { text: 'Nomor', value: 'ipNo'},
          { text: 'Judul', value: 'ipJudulPekerjaan' },
          { text: 'Tanggal', value: 'ipDateFormat' },
          { text: 'Form', value: 'ipFormShortName' },
          { text: 'Nama', value: 'ipKaryawan.name' },
          { text: 'Action', value: 'actions', sortable: false },
        ],
        items: []
      },
    }
  },
  mounted () {
    this.$store.dispatch("fetchPrintEwaskatList")
  },
  computed: {
    ...mapState(["printEwaskatList","API_URL","dataUsers"]),
  },
  methods: {
    getWITADate:helper.getWITADate,
    formatDate:helper.formatDate,
    getIp() {
      this.ip.items = this.printEwaskatList.data;
      this.ip.jumlah = this.printEwaskatList.jumlah;

      if(this.ip.items){
        for (let i = 0; i < this.ip.items.length; i++) {
          this.ip.items[i].ipFormShortName = this.config.ShortenFormName[this.ip.items[i].ipForm];
          this.ip.items[i].ipDateFormat = this.formatDate(this.ip.items[i].ipDate);
        }
      }

      return this.ip;
    },
  },
};
</script>
